import React from "react";
import { ArrowUp, ArrowDown, Check, List, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { cn } from "@/lib/format";

// ---------- pagination controls ----------
export const Controls = ({
  page,
  setPage,
  count,
  setCount,
  countOptions = [10, 25, 50, 100],
  order,
  setOrder,
  viewAll,
  setViewAll,
  startIdx,
  endIdx,
  resultCount,
  pageRowCount,
  testidPrefix,
}) => (
  <div className="sticky top-0 z-10 bg-background/95 backdrop-blur-sm border-b border-border/40 flex flex-wrap items-center justify-between gap-3 py-2 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
    <div className="flex items-center gap-4">
      <label className="inline-flex items-center gap-2">
        <span>count</span>
        <select
          data-testid={`${testidPrefix}-count`}
          value={count}
          onChange={(e) => {
            setPage(1);
            setCount(Number(e.target.value));
          }}
          className="bg-card border border-border/70 px-2 py-1 text-foreground mono tracking-normal"
        >
          {countOptions.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </label>
      <button
        data-testid={`${testidPrefix}-order`}
        onClick={() => {
          setPage(1);
          setOrder(order === "asc" ? "desc" : "asc");
        }}
        className="inline-flex items-center gap-1 border border-border/70 bg-card px-2 py-1 text-foreground hover:bg-muted/30 tracking-normal mono"
      >
        {order === "asc" ? <ArrowUp size={11} /> : <ArrowDown size={11} />}
        {order}
      </button>
      {setViewAll ? (
        <button
          data-testid={`${testidPrefix}-view-all`}
          onClick={() => setViewAll(!viewAll)}
          className={cn(
            "inline-flex items-center gap-1.5 border border-border/70 px-2 py-1 hover:bg-muted/30 tracking-[0.18em] transition-colors",
            viewAll
              ? "bg-primary/10 text-primary border-primary/40"
              : "bg-card text-muted-foreground",
          )}
          title={viewAll ? "Switch back to paged view" : "Continuous list (Cardanoscan-style)"}
        >
          {viewAll ? <Check size={11} /> : <List size={11} />}
          view all
        </button>
      ) : null}
    </div>
    <div className="flex items-center gap-3">
      <span className="mono tracking-normal text-foreground/80">
        {resultCount === 0
          ? "no rows"
          : viewAll
            ? `${resultCount} loaded`
            : `rows ${startIdx}–${endIdx}`}
        {!viewAll ? (
          <span className="text-muted-foreground"> · page {page}</span>
        ) : null}
      </span>
      {!viewAll ? (
        <div className="flex items-center gap-1">
          <button
            data-testid={`${testidPrefix}-prev`}
            onClick={() => setPage(Math.max(1, page - 1))}
            disabled={page === 1}
            className="w-7 h-7 flex items-center justify-center border border-border/70 bg-card disabled:opacity-40 hover:bg-muted/30"
          >
            <CaretLeft size={12} />
          </button>
          <button
            data-testid={`${testidPrefix}-next`}
            onClick={() => setPage(page + 1)}
            disabled={pageRowCount < count}
            className="w-7 h-7 flex items-center justify-center border border-border/70 bg-card disabled:opacity-40 hover:bg-muted/30"
          >
            <CaretRight size={12} />
          </button>
        </div>
      ) : null}
    </div>
  </div>
);
